export const NOTIFICATIONS_PAGE_SIZE = 20

/**
 * Every key carries the account id: the query cache outlives a session in a
 * tab, and a key without the id would hand the next account the previous
 * one's feed and badge.
 */
export const notificationsQueryKeys = {
  all: ['notifications'] as const,
  user: (userId: string) => ['notifications', userId] as const,
  list: (userId: string) => ['notifications', userId, 'list'] as const,
  unreadCount: (userId: string) =>
    ['notifications', userId, 'unread-count'] as const,
  settings: (userId: string) => ['notifications', userId, 'settings'] as const,
  push: (userId: string) => ['notifications', userId, 'push'] as const
}
